(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-announcement-dismiss]');
    if (!btn) return;
    var id = btn.getAttribute('data-announcement-dismiss');
    var bar = document.getElementById('announcement-' + id);
    if (bar) {
      bar.style.display = 'none';
      try { sessionStorage.setItem('announcement-' + id, 'dismissed'); } catch(e) {}
    }
  });

  document.querySelectorAll('[id^="announcement-"]').forEach(function(bar) {
    var id = bar.id.replace('announcement-', '');
    try {
      if (sessionStorage.getItem('announcement-' + id) === 'dismissed') {
        bar.style.display = 'none';
      }
    } catch(e) {}
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (function() {
    var drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;

    var closeButtons = drawer.querySelectorAll('[data-cart-drawer-close]');
    var panel = drawer.querySelector('.cart-drawer__panel');
    var triggers = document.querySelectorAll('[data-cart-toggle]');
    var lastActiveElement = null;

    function setOpen(isOpen) {
      drawer.classList.toggle('is-open', isOpen);
      drawer.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
      document.body.classList.toggle('cart-drawer-open', isOpen);

      triggers.forEach(function(trigger) {
        trigger.setAttribute('aria-controls', panel ? panel.id : '');
        trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });

      if (isOpen) {
        lastActiveElement = document.activeElement;
        if (panel) panel.focus();
      } else if (lastActiveElement && typeof lastActiveElement.focus === 'function') {
        lastActiveElement.focus();
      }
    }

    function trapFocus(event) {
      if (event.key !== 'Tab' || !drawer.classList.contains('is-open')) return;
      if (!panel) return;

      var focusableElements = panel.querySelectorAll(
        'a[href], button:not([disabled]), textarea:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'
      );
      if (!focusableElements.length) {
        event.preventDefault();
        return;
      }

      var first = focusableElements[0];
      var last = focusableElements[focusableElements.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    triggers.forEach(function(trigger) {
      trigger.addEventListener('click', function(event) {
        event.preventDefault();
        setOpen(true);
      });
    });

    closeButtons.forEach(function(button) {
      button.addEventListener('click', function() {
        setOpen(false);
      });
    });

    document.addEventListener('keydown', function(event) {
      if (!drawer.classList.contains('is-open')) return;
      if (event.key === 'Escape') {
        setOpen(false);
        return;
      }
      trapFocus(event);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  class CollectionFilterDrawer {
    constructor() {
      this.toggle = document.querySelector('[data-filter-toggle]');
      this.drawer = document.querySelector('[data-filter-drawer]');
      this.overlay = document.querySelector('[data-filter-overlay]');
      this.closeBtn = document.querySelector('[data-filter-close]');
      this.countBadge = document.querySelector('[data-filter-count]');

      if (!this.toggle || !this.drawer) return;

      this.init();
    }

    init() {
      this.toggle.addEventListener('click', () => this.open());
      this.closeBtn?.addEventListener('click', () => this.close());
      this.overlay?.addEventListener('click', () => this.close());
      
      // Close on Escape key
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.drawer.classList.contains('is-open')) {
          this.close();
        }
      });

      // Update active filter count
      this.updateFilterCount();
      
      // Listen for filter changes
      const form = this.drawer.querySelector('[data-faceted-form]');
      if (form) {
        form.addEventListener('change', () => {
          setTimeout(() => this.updateFilterCount(), 100);
        });
      }
    }

    open() {
      this.drawer.classList.add('is-open');
      this.overlay?.classList.add('is-visible');
      this.toggle.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      
      // Focus first interactive element
      const firstInput = this.drawer.querySelector('input, button');
      firstInput?.focus();
    }

    close() {
      this.drawer.classList.remove('is-open');
      this.overlay?.classList.remove('is-visible');
      this.toggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      this.toggle.focus();
    }

    updateFilterCount() {
      const activeFilters = this.drawer.querySelectorAll('input[type="checkbox"]:checked, input[type="number"][value]:not([value=""])');
      const count = activeFilters.length;
      
      if (this.countBadge) {
        this.countBadge.textContent = count > 0 ? count : '';
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => new CollectionFilterDrawer());
  } else {
    new CollectionFilterDrawer();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["complementary-products"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('[data-complementary-products]').forEach(function(root) {
      var productId = root.getAttribute('data-product-id');
      if (!productId) return;

      var sectionId = root.getAttribute('data-section-id');
      var limit = root.getAttribute('data-limit') || '4';
      var grid = root.querySelector('[data-complementary-products-grid]');
      if (!grid) return;

      var url = '/recommendations/products?section_id=' + encodeURIComponent(sectionId)
        + '&product_id=' + encodeURIComponent(productId)
        + '&limit=' + encodeURIComponent(limit)
        + '&intent=complementary';

      fetch(url)
        .then(function(res) { return res.text(); })
        .then(function(html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var newSection = doc.querySelector('[data-complementary-products]');
          if (newSection) {
            root.innerHTML = newSection.innerHTML;
          }
        })
        .catch(function() {
          /* Hide section gracefully on error */
          var placeholder = root.querySelector('[data-complementary-products-placeholder]');
          if (placeholder) {
            placeholder.remove();
          }
        });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["countdown-timer"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('[data-countdown-root]').forEach(function(root) {
      var targetDateRaw = root.getAttribute('data-target-date');
      if (!targetDateRaw) return;

      var target = new Date(targetDateRaw).getTime();
      if (Number.isNaN(target)) return;

      var grid = root.querySelector('[data-countdown-grid]');
      var expiredNode = root.querySelector('[data-countdown-expired]');
      var daysNode = root.querySelector('[data-countdown-days]');
      var hoursNode = root.querySelector('[data-countdown-hours]');
      var minutesNode = root.querySelector('[data-countdown-minutes]');
      var secondsNode = root.querySelector('[data-countdown-seconds]');
      if (!daysNode || !hoursNode || !minutesNode || !secondsNode) return;

      function pad(value) {
        return String(value).padStart(2, '0');
      }

      function render() {
        var now = Date.now();
        var diff = target - now;
        if (diff <= 0) {
          daysNode.textContent = '00';
          hoursNode.textContent = '00';
          minutesNode.textContent = '00';
          secondsNode.textContent = '00';
          if (expiredNode) expiredNode.hidden = false;
          if (grid) grid.setAttribute('aria-hidden', 'true');
          return true;
        }

        var days = Math.floor(diff / (1000 * 60 * 60 * 24));
        var hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
        var minutes = Math.floor((diff / (1000 * 60)) % 60);
        var seconds = Math.floor((diff / 1000) % 60);

        daysNode.textContent = pad(days);
        hoursNode.textContent = pad(hours);
        minutesNode.textContent = pad(minutes);
        secondsNode.textContent = pad(seconds);
        return false;
      }

      var done = render();
      if (done) return;

      var timer = window.setInterval(function() {
        if (render()) {
          window.clearInterval(timer);
        }
      }, 1000);
    });
  }());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('[data-featured-carousel]').forEach(function(carousel) {
      var section = carousel.closest('.featured-collection');
      if (!section) return;
      var track = carousel.querySelector('.featured-collection__track');
      if (!track) return;
      var prevBtn = section.querySelector('[data-featured-scroll-prev]');
      var nextBtn = section.querySelector('[data-featured-scroll-next]');
      if (!prevBtn || !nextBtn) return;

      function step() {
        return Math.max(track.clientWidth * 0.85, 220);
      }

      prevBtn.addEventListener('click', function() {
        track.scrollBy({ left: -step(), behavior: 'smooth' });
      });

      nextBtn.addEventListener('click', function() {
        track.scrollBy({ left: step(), behavior: 'smooth' });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collections-row"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('[data-featured-collections-carousel]').forEach(function(carousel) {
      var section = carousel.closest('.featured-collections-row');
      if (!section) return;
      var track = carousel.querySelector('.featured-collections-row__track');
      if (!track) return;
      var prevBtn = section.querySelector('[data-featured-collections-prev]');
      var nextBtn = section.querySelector('[data-featured-collections-next]');
      if (!prevBtn || !nextBtn) return;

      function step() {
        return Math.max(track.clientWidth * 0.85, 220);
      }

      function directionAdjustedAmount(baseAmount) {
        var isRtl = window.getComputedStyle(track).direction === 'rtl';
        return isRtl ? -baseAmount : baseAmount;
      }

      prevBtn.addEventListener('click', function() {
        track.scrollBy({ left: directionAdjustedAmount(-step()), behavior: 'smooth' });
      });

      nextBtn.addEventListener('click', function() {
        track.scrollBy({ left: directionAdjustedAmount(step()), behavior: 'smooth' });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var root = document.querySelector('[data-featured-product]');
    if (!root) return;

    var form = root.querySelector('[data-featured-product-form]');
    if (!form) return;

    var variantsNode = form.querySelector('[data-featured-variants]');
    var variantIdInput = form.querySelector('[data-featured-variant-id]');
    var optionInputs = form.querySelectorAll('[data-featured-option]');
    var addButton = form.querySelector('[data-featured-add-button]');
    var dynamicCheckout = form.querySelector('[data-featured-dynamic-checkout]');

    if (!variantsNode || !variantIdInput || optionInputs.length === 0) return;

    var variants = [];
    try {
      variants = JSON.parse(variantsNode.textContent);
    } catch (error) {
      return;
    }

    function syncVariant() {
      var selectedOptions = Array.prototype.map.call(optionInputs, function(input) {
        return input.value;
      });

      var matchedVariant = variants.find(function(variant) {
        return selectedOptions.every(function(optionValue, index) {
          return variant.options[index] === optionValue;
        });
      });

      if (!matchedVariant) {
        if (addButton) {
          addButton.disabled = true;
          addButton.textContent = addButton.getAttribute('data-sold-label') || '';
        }
        return;
      }

      variantIdInput.value = matchedVariant.id;

      if (addButton) {
        if (matchedVariant.available) {
          addButton.disabled = false;
          addButton.textContent = addButton.getAttribute('data-add-label') || '';
        } else {
          addButton.disabled = true;
          addButton.textContent = addButton.getAttribute('data-sold-label') || '';
        }
      }

      if (dynamicCheckout) {
        dynamicCheckout.hidden = !matchedVariant.available;
      }
    }

    optionInputs.forEach(function(input) {
      input.addEventListener('change', syncVariant);
    });

    syncVariant();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function() {
    var mobileDrawer = document.querySelector('[data-mobile-drawer]');
    var mobileToggle = document.querySelector('[data-mobile-drawer-toggle]');

    if (mobileDrawer && mobileToggle) {
      var closers = mobileDrawer.querySelectorAll('[data-mobile-drawer-close]');
      var drawerPanel = mobileDrawer.querySelector('.mobile-drawer__panel');
      var lastActiveElement = null;

      function toggleMobileDrawer(isOpen) {
        mobileDrawer.classList.toggle('is-open', isOpen);
        mobileDrawer.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
        mobileToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        document.body.classList.toggle('mobile-drawer-open', isOpen);

        if (isOpen) {
          lastActiveElement = document.activeElement;
          if (drawerPanel) {
            drawerPanel.focus();
          }
        } else if (lastActiveElement && typeof lastActiveElement.focus === 'function') {
          lastActiveElement.focus();
        }
      }

      function trapFocus(event) {
        if (event.key !== 'Tab' || !mobileDrawer.classList.contains('is-open')) return;
        if (!drawerPanel) return;

        var focusableElements = drawerPanel.querySelectorAll(
          'a[href], button:not([disabled]), textarea:not([disabled]), input:not([disabled]), select:not([disabled]), details summary, [tabindex]:not([tabindex="-1"])'
        );
        if (!focusableElements.length) {
          event.preventDefault();
          return;
        }

        var first = focusableElements[0];
        var last = focusableElements[focusableElements.length - 1];

        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }

      mobileToggle.addEventListener('click', function() {
        toggleMobileDrawer(true);
      });

      closers.forEach(function(closer) {
        closer.addEventListener('click', function() {
          toggleMobileDrawer(false);
        });
      });

      document.addEventListener('keydown', function(event) {
        if (!mobileDrawer.classList.contains('is-open')) return;
        if (event.key === 'Escape') {
          toggleMobileDrawer(false);
          return;
        }
        trapFocus(event);
      });
    }

    var header = document.querySelector('[data-header]');
    if (!header || header.dataset.stickyBehavior !== 'on-scroll-up') return;

    var lastY = window.scrollY;
    window.addEventListener('scroll', function() {
      var currentY = window.scrollY;
      if (currentY <= 10) {
        header.classList.remove('header--hidden');
        lastY = currentY;
        return;
      }
      if (currentY > lastY) {
        header.classList.add('header--hidden');
      } else {
        header.classList.remove('header--hidden');
      }
      lastY = currentY;
    }, { passive: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-comparison"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('[data-image-comparison]').forEach(function(root) {
      var frame = root.querySelector('[data-comparison-frame]');
      var range = root.querySelector('[data-comparison-range]');
      if (!frame || !range) return;

      function update() {
        var value = Number(range.value) || 50;
        var isRtl = document.documentElement.getAttribute('dir') === 'rtl';
        var logical = isRtl ? 100 - value : value;
        frame.style.setProperty('--comparison-position', logical + '%');
      }

      range.addEventListener('input', update);
      update();
    });
  }());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["password"]) return;
  try {
    
  (function() {
    document.querySelectorAll('[data-password-section]').forEach(function(root) {
      var dateRaw = root.getAttribute('data-launch-date');
      if (!dateRaw) return;
      var target = new Date(dateRaw).getTime();
      if (Number.isNaN(target)) return;

      var daysNode = root.querySelector('[data-password-days]');
      var hoursNode = root.querySelector('[data-password-hours]');
      var minutesNode = root.querySelector('[data-password-minutes]');
      if (!daysNode || !hoursNode || !minutesNode) return;

      function pad(v) { return String(v).padStart(2, '0'); }
      function update() {
        var diff = target - Date.now();
        if (diff <= 0) {
          daysNode.textContent = '00';
          hoursNode.textContent = '00';
          minutesNode.textContent = '00';
          return true;
        }
        var days = Math.floor(diff / 86400000);
        var hours = Math.floor((diff / 3600000) % 24);
        var mins = Math.floor((diff / 60000) % 60);
        daysNode.textContent = pad(days);
        hoursNode.textContent = pad(hours);
        minutesNode.textContent = pad(mins);
        return false;
      }

      if (!update()) {
        var timer = window.setInterval(function() {
          if (update()) window.clearInterval(timer);
        }, 1000);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popup"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('[data-popup-root]').forEach(function(root) {
      var dialog = root.querySelector('[data-popup-dialog]');
      var closeBtn = root.querySelector('[data-popup-close]');
      if (!dialog || !closeBtn) return;

      var storageKey = root.getAttribute('data-storage-key');
      var delay = Number(root.getAttribute('data-delay')) || 3;
      var lastActiveElement = null;

      try {
        if (localStorage.getItem(storageKey) === '1') return;
      } catch (e) {
      }

      window.setTimeout(function() {
        if (!dialog.open) {
          lastActiveElement = document.activeElement;
          dialog.showModal();
          closeBtn.focus();
        }
      }, delay * 1000);

      function dismiss() {
        dialog.close();
        if (lastActiveElement && typeof lastActiveElement.focus === 'function') {
          lastActiveElement.focus();
        }
        try {
          localStorage.setItem(storageKey, '1');
        } catch (e) {
        }
      }

      closeBtn.addEventListener('click', dismiss);
      dialog.addEventListener('click', function(event) {
        var rect = dialog.getBoundingClientRect();
        var inside = rect.top <= event.clientY && event.clientY <= rect.top + rect.height && rect.left <= event.clientX && event.clientX <= rect.left + rect.width;
        if (!inside) dismiss();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('[data-product-recommendations]').forEach(function(root) {
      var productId = root.getAttribute('data-product-id');
      if (!productId) return;

      var sectionId = root.getAttribute('data-section-id');
      var limit = root.getAttribute('data-limit') || '4';
      var grid = root.querySelector('[data-product-recommendations-grid]');
      if (!grid) return;

      var url = '/recommendations/products?section_id=' + encodeURIComponent(sectionId) + '&product_id=' + encodeURIComponent(productId) + '&limit=' + encodeURIComponent(limit);

      fetch(url)
        .then(function(res) { return res.text(); })
        .then(function(html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var replacement = doc.querySelector('[data-product-recommendations-grid]');
          if (replacement) {
            grid.innerHTML = replacement.innerHTML;
          }
        })
        .catch(function() {
          var empty = root.querySelector('[data-product-recommendations-empty]');
          if (empty) {
            empty.textContent = root.getAttribute('data-no-results-label') || '';
          }
        });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function() {
    document.addEventListener('click', function(e) {
      var thumb = e.target.closest('[data-thumb-index]');
      if (!thumb) return;

      var index = thumb.getAttribute('data-thumb-index');
      var container = thumb.closest('.product-media');
      var items = container.querySelectorAll('[data-media-index]');
      var thumbs = container.querySelectorAll('[data-thumb-index]');

      items.forEach(function(item) {
        item.classList.toggle('product-media__item--active', item.getAttribute('data-media-index') === index);
      });

      thumbs.forEach(function(t) {
        t.classList.toggle('product-media__thumb--active', t.getAttribute('data-thumb-index') === index);
      });
    });

    var productForm = document.querySelector('[data-product-form]');
    if (!productForm) return;

    var variantsNode = productForm.querySelector('[data-product-variants]');
    var variantIdInput = productForm.querySelector('[data-product-variant-id]');
    var optionInputs = productForm.querySelectorAll('[data-product-option]');
    var addButton = productForm.querySelector('[data-add-to-cart-button]');
    var skuNode = document.querySelector('[data-product-sku]');
    var dynamicCheckoutWrapper = productForm.querySelector('[data-dynamic-checkout-wrapper]');
    var pickupContainer = document.querySelector('[data-pickup-availability]');

    if (!variantsNode || !variantIdInput || optionInputs.length === 0) return;

    var variants = [];
    try {
      variants = JSON.parse(variantsNode.textContent);
    } catch (error) {
      return;
    }

    function updateVariant() {
      var selectedOptions = Array.prototype.map.call(optionInputs, function(input) {
        return input.value;
      });

      var matchedVariant = variants.find(function(variant) {
        return selectedOptions.every(function(optionValue, index) {
          return variant.options[index] === optionValue;
        });
      });

      if (!matchedVariant) {
        if (addButton) {
          addButton.disabled = true;
          addButton.textContent = addButton.getAttribute('data-sold-out-label') || '';
        }
        return;
      }

      variantIdInput.value = matchedVariant.id;

      if (skuNode) {
        skuNode.textContent = matchedVariant.sku || '';
      }

      if (addButton) {
        if (matchedVariant.available) {
          addButton.disabled = false;
          addButton.textContent = addButton.getAttribute('data-add-to-cart-label') || '';
        } else {
          addButton.disabled = true;
          addButton.textContent = addButton.getAttribute('data-sold-out-label') || '';
        }
      }

      if (dynamicCheckoutWrapper) {
        dynamicCheckoutWrapper.hidden = !matchedVariant.available;
      }

      if (pickupContainer) {
        var sectionId = pickupContainer.getAttribute('data-section-id');
        var productUrl = pickupContainer.getAttribute('data-product-url');
        var url = productUrl + '?variant=' + matchedVariant.id + '&section_id=' + sectionId;
        fetch(url)
          .then(function(res) { return res.text(); })
          .then(function(html) {
            var parser = new DOMParser();
            var doc = parser.parseFromString(html, 'text/html');
            var newPickup = doc.querySelector('[data-pickup-availability]');
            if (newPickup) {
              pickupContainer.innerHTML = newPickup.innerHTML;
            }
          })
          .catch(function() {});
      }
    }

    optionInputs.forEach(function(optionInput) {
      optionInput.addEventListener('change', updateVariant);
    });

    updateVariant();

    var sellingPlanInput = productForm.querySelector('[data-selling-plan-input]');
    var sellingPlanRadios = productForm.querySelectorAll('[data-selling-plan-radio]');

    if (sellingPlanInput && sellingPlanRadios.length > 0) {
      sellingPlanRadios.forEach(function(radio) {
        radio.addEventListener('change', function() {
          sellingPlanInput.value = radio.value;
        });
      });
    }

    var productPage = document.querySelector('[data-product-page]');
    if (productPage) {
      var handle = productPage.getAttribute('data-product-handle');
      if (handle) {
        try {
          var key = 'souk_recently_viewed';
          var handles = JSON.parse(localStorage.getItem(key) || '[]');
          handles = handles.filter(function(item) { return item !== handle; });
          handles.unshift(handle);
          localStorage.setItem(key, JSON.stringify(handles.slice(0, 12)));
        } catch (e) {
        }
      }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quick-view"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var root = document.querySelector('[data-quick-view-root]');
    if (!root) return;

    var dialog = root.querySelector('[data-quick-view-dialog]');
    var closeBtn = root.querySelector('[data-quick-view-close]');
    var content = root.querySelector('[data-quick-view-content]');
    if (!dialog || !closeBtn || !content) return;
    var loadingLabel = root.getAttribute('data-loading-label') || 'Loading';
    var noResultsLabel = root.getAttribute('data-no-results-label') || 'No results';
    var viewProductLabel = root.getAttribute('data-view-product-label') || 'View all';
    var localeCode = root.getAttribute('data-locale') || document.documentElement.lang || '';
    var routesRoot = root.getAttribute('data-routes-root') || ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/');
    var lastActiveElement = null;

    var moneyFormat = root.getAttribute('data-money-format') || '';

    function normalizeRoot(path) {
      if (!path) return '/';
      var normalized = path;
      if (normalized.charAt(0) !== '/') normalized = '/' + normalized;
      if (normalized.charAt(normalized.length - 1) !== '/') normalized += '/';
      return normalized;
    }

    function buildProductPath(handle, asJson) {
      var path = normalizeRoot(routesRoot) + 'products/' + encodeURIComponent(handle) + (asJson ? '.js' : '');
      if (asJson && localeCode) {
        path += '?locale=' + encodeURIComponent(localeCode);
      }
      return path;
    }

    function escapeHtml(str) {
      return String(str == null ? '' : str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }

    function formatMoney(cents, format) {
      if (cents == null || !format) return '';
      var amount = (cents / 100).toFixed(2);
      var parts = amount.split('.');
      var withComma = parts[0] + ',' + parts[1];
      var noDecimals = parts[0];
      var withSpaceSeparator = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ') + ',' + parts[1];
      var withApostropheSeparator = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1'") + '.' + parts[1];
      var placeholders = [
        ['amount_with_apostrophe_separator', withApostropheSeparator],
        ['amount_with_comma_separator', withComma],
        ['amount_with_space_separator', withSpaceSeparator],
        ['amount_no_decimals_with_comma_separator', noDecimals],
        ['amount_no_decimals', noDecimals],
        ['amount', amount]
      ];
      var result = format;
      for (var i = 0; i < placeholders.length; i++) {
        var key = placeholders[i][0];
        var val = placeholders[i][1];
        result = result.replace(new RegExp('\\{\\{\\s*' + key + '\\s*\\}\\}', 'g'), val);
      }
      return result;
    }

    function renderProduct(product, handle) {
      var image = product.featured_image ? '<img src="' + product.featured_image + '&width=900" alt="' + escapeHtml(product.title || '') + '">' : '';
      var desc = (product.description || '').replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim().slice(0, 220);
      var price = formatMoney(product.price, moneyFormat);
      var productUrl = buildProductPath(product.handle || handle, false);

      content.innerHTML =
        '<div class="quick-view__media">' + image + '</div>' +
        '<div class="quick-view__details">' +
          '<h3>' + escapeHtml(product.title || '') + '</h3>' +
          '<p>' + escapeHtml(price) + '</p>' +
          '<p>' + escapeHtml(desc) + '</p>' +
          '<a class="btn btn--primary quick-view__cta" href="' + productUrl + '">' + escapeHtml(viewProductLabel) + '</a>' +
        '</div>';
    }

    document.addEventListener('click', function(event) {
      var trigger = event.target.closest('[data-quick-view-trigger]');
      if (!trigger) return;
      event.preventDefault();

      var handle = trigger.getAttribute('data-product-handle');
      if (!handle) return;

      lastActiveElement = trigger;
      content.innerHTML = '<p class="quick-view__loading">' + loadingLabel + '...</p>';
      dialog.showModal();

      fetch(buildProductPath(handle, true))
        .then(function(res) { return res.ok ? res.json() : null; })
        .then(function(product) {
          if (!product) {
            content.innerHTML = '<p class="quick-view__loading">' + noResultsLabel + '</p>';
            return;
          }
          renderProduct(product, handle);
        })
        .catch(function() {
          content.innerHTML = '<p class="quick-view__loading">' + noResultsLabel + '</p>';
        });
    });

    function closeDialog() {
      dialog.close();
      if (lastActiveElement && typeof lastActiveElement.focus === 'function') {
        lastActiveElement.focus();
      }
    }

    closeBtn.addEventListener('click', function() {
      closeDialog();
    });

    dialog.addEventListener('click', function(event) {
      var rect = dialog.getBoundingClientRect();
      var inside = rect.top <= event.clientY && event.clientY <= rect.top + rect.height && rect.left <= event.clientX && event.clientX <= rect.left + rect.width;
      if (!inside) closeDialog();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recently-viewed"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('[data-recently-viewed]').forEach(function(root) {
      var grid = root.querySelector('[data-recently-viewed-grid]');
      var empty = root.querySelector('[data-recently-viewed-empty]');
      if (!grid || !empty) return;

      var limit = Number(root.getAttribute('data-limit')) || 4;
      var moneyFormat = root.getAttribute('data-money-format') || '';
      var key = 'souk_recently_viewed';
      var handles = [];

      function formatMoney(cents, format) {
        if (cents == null || !format) return '';
        var amount = (cents / 100).toFixed(2);
        var parts = amount.split('.');
        var withComma = parts[0] + ',' + parts[1];
        var noDecimals = parts[0];
        var withSpaceSeparator = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ') + ',' + parts[1];
        var withApostropheSeparator = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1'") + '.' + parts[1];
        var placeholders = [
          ['amount_with_apostrophe_separator', withApostropheSeparator],
          ['amount_with_comma_separator', withComma],
          ['amount_with_space_separator', withSpaceSeparator],
          ['amount_no_decimals_with_comma_separator', noDecimals],
          ['amount_no_decimals', noDecimals],
          ['amount', amount]
        ];
        var result = format;
        for (var i = 0; i < placeholders.length; i++) {
          var k = placeholders[i][0];
          var val = placeholders[i][1];
          result = result.replace(new RegExp('\\{\\{\\s*' + k + '\\s*\\}\\}', 'g'), val);
        }
        return result;
      }

      try {
        handles = JSON.parse(localStorage.getItem(key) || '[]');
      } catch (e) {
        handles = [];
      }

      if (!handles.length) return;

      var selected = handles.slice(0, limit);
      Promise.all(selected.map(function(handle) {
        return fetch('/products/' + handle + '.js')
          .then(function(res) { return res.ok ? res.json() : null; })
          .catch(function() { return null; });
      })).then(function(products) {
        var list = products.filter(Boolean);
        if (!list.length) return;

        empty.remove();
        list.forEach(function(product) {
          var item = document.createElement('a');
          item.className = 'recently-viewed__item';
          item.href = product.url;

          var image = product.featured_image ? '<img src="' + product.featured_image + '&width=700" alt="' + (product.title || '') + '">' : '';
          var price = formatMoney(product.price, moneyFormat);
          item.innerHTML = image + '<div class="recently-viewed__meta"><p class="recently-viewed__title">' + product.title + '</p><p class="recently-viewed__price">' + price + '</p></div>';
          grid.appendChild(item);
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var root = document.querySelector('[data-slideshow]');
    if (!root) return;

    var track = root.querySelector('.slideshow__track');
    var slides = Array.from(root.querySelectorAll('.slideshow__slide'));
    var dots = Array.from(root.querySelectorAll('[data-slide-dot]'));
    var prevButton = root.querySelector('[data-slide-prev]');
    var nextButton = root.querySelector('[data-slide-next]');

    if (slides.length <= 1 || !track) return;

    var currentIndex = 0;
    var timer = null;
    var autoplayEnabled = root.dataset.autoplay === 'true';
    var speed = parseInt(root.dataset.speed, 10) || 5000;

    function setSlide(index) {
      if (index < 0) index = slides.length - 1;
      if (index >= slides.length) index = 0;
      currentIndex = index;
      track.style.transform = 'translateX(' + (-100 * currentIndex) + '%)';
      dots.forEach(function(dot, dotIndex) {
        var active = dotIndex === currentIndex;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    }

    function startAutoplay() {
      if (!autoplayEnabled) return;
      stopAutoplay();
      timer = window.setInterval(function() {
        setSlide(currentIndex + 1);
      }, speed);
    }

    function stopAutoplay() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    if (prevButton) {
      prevButton.addEventListener('click', function() {
        setSlide(currentIndex - 1);
        startAutoplay();
      });
    }

    if (nextButton) {
      nextButton.addEventListener('click', function() {
        setSlide(currentIndex + 1);
        startAutoplay();
      });
    }

    dots.forEach(function(dot) {
      dot.addEventListener('click', function() {
        setSlide(parseInt(dot.dataset.slideDot, 10));
        startAutoplay();
      });
    });

    root.addEventListener('mouseenter', stopAutoplay);
    root.addEventListener('mouseleave', startAutoplay);

    setSlide(0);
    startAutoplay();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('[data-video-section]').forEach(function(root) {
      var openButton = root.querySelector('[data-video-open]');
      var embed = root.querySelector('[data-video-embed]');
      if (!openButton || !embed) return;

      openButton.addEventListener('click', function() {
        openButton.setAttribute('hidden', 'hidden');
        embed.classList.remove('is-hidden');
      });
    });
  }());

  } catch(e) { console.error(e); }
})();
})();
